import { TFunction } from 'i18next';
import { Theme } from '@mui/material';

import { CaseStatus } from '@bandido/shared/constants';

export const caseStatusOptions = (theme: Theme, t: TFunction<'translation', undefined>) =>
  (Object.keys(CaseStatus) as Array<keyof typeof CaseStatus>).map((status) => ({
    value: status,
    name: t(`cases.status.${status}`),
    color: theme.palette.cases[status].bg,
    textColor: theme.palette.cases[status].text,
  }));
